import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  class: "logo",
  viewBox: "0 0 68 68"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M34.27 68c18.778 0 34-15.222 34-34s-15.222-34-34-34-34 15.222-34 34 15.222 34 34 34"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#fff",
      d: "M43.932 47.324c-.102.985-1.14 1.344-2.225 1.344-2.597 0-3.016-1.267-2.884-3.754.311-5.86 6.461-15.66 6.959-18.709-2.924.746-10.616 10.047-12.313 17.225a34 34 0 0 0-.53 4.11c-.114.937-.288 1.128-1.843 1.128-2.24 0-3.433-.754-3.423-2.862.037-7.405 6.162-17.237 6.846-19.6-2.926.745-11.04 11.535-12.292 16.954a28.6 28.6 0 0 0-.584 4.452c-.067.706-.254 1.056-1.81 1.056-2.24 0-3.422-1.228-3.422-2.862 0-7.405 8.412-24.336 9.52-25.381 1.87-1.77 4.651-1.41 4.714 1.229a5.5 5.5 0 0 1-1.415 3.555 63 63 0 0 0-5.165 11.137h.125c5.598-10.08 9.955-16.114 12.445-16.114a3.925 3.925 0 0 1 4.231 3.67c0 1.555-3.672 6.098-5.538 12.444h.123c5.601-10.08 9.957-16.114 12.447-16.114a3.926 3.926 0 0 1 4.231 3.67c0 1.93-2.283 5.33-3.921 8.774A40.6 40.6 0 0 0 44.41 43.33a31 31 0 0 0-.478 3.994"
    }, null, -1)
  ])))
}
export default { render: render }